import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/posts/[location]/[category]/ClientPage.tsx");
